import * as React from 'react';
import Svg, {Path, Rect} from 'react-native-svg';
import {backgroundColor} from 'src/components/img/svg/rewards/PayEarnPoints';
interface IProps {
  color?: string;
  width?: number;
  height?: number;
}
const PayExclusiveRewards = ({
  width = 51,
  height = 50,
  color = '#006DFF',
}: IProps) => (
  <Svg width={51} height={50} viewBox="0 0 51 50" fill="none">
    <Rect
      x={0.75}
      width={width}
      height={height}
      rx={8}
      fill={backgroundColor(color).color}
      fillOpacity={backgroundColor(color).opacity}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.465 23.415zM24.806 13.394h2.455c.237 0 .421-.205.396-.44l-.19-1.765a.398.398 0 00-.396-.355h-2.076a.398.398 0 00-.395.355l-.19 1.764a.398.398 0 00.396.44zM30.102 38.356a.397.397 0 01-.422-.052l-.39-.318-.454.214a.399.399 0 01-.529-.534l.635-1.316 1.5-12.113-.294-1.431a.398.398 0 01.643-.389l.334.274v-1.575c0-5.073-3.844-6.08-3.844-7.236h-2.476c0 .98-2.765 1.854-3.605 5.193h.003l.404-.352a.398.398 0 01.427-.063l.489.222.404-.353a.399.399 0 01.427-.063l.489.222.404-.353a.398.398 0 01.427-.062l.488.221.403-.351a.397.397 0 01.254-.1H25.837a.398.398 0 01.382.48l-.263 1.494c.503 1.615.997 3.949 1.36 6.428.365 2.48.563 4.858.546 6.548l.687 1.367a.399.399 0 01-.521.542l-.489-.222-.404.353a.398.398 0 01-.427.063l-.489-.222-.404.353a.398.398 0 01-.427.063l-.488-.222-.405.353a.398.398 0 01-.427.062l-.488-.221-.404.352a.398.398 0 01-.427.063l-.489-.222-.404.353a.398.398 0 01-.427.063l-.468-.213v.858a2.653 2.653 0 002.652 2.653h4.86c.849 0 1.604-.4 2.09-1.02l-.006-.004-.455.213z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.869 23.51l-.683.32-.583-.477-.683.32-.583-.477-.683.32-.584-.477-.682.32-.584-.477-.682.32-.584-.476.308 1.495-1.517 12.243-.663 1.375.683-.32.583.477.683-.32.583.476.683-.32.584.477.682-.32.584.477.682-.32.584.477-.308-1.495 1.517-12.244.663-1.374zM20.407 31.549a4.09 4.09 0 01-4.043-3.497 4.065 4.065 0 01.766-3.036 4.064 4.064 0 013.287-1.65 4.089 4.089 0 014.042 3.497 4.064 4.064 0 01-.765 3.036 4.064 4.064 0 01-3.287 1.65zm1.784 3.435l.723.328.597-.522.722.328.598-.521.722.328.598-.522.722.328.597-.522.723.328-.73-1.454c.024-1.614-.157-3.974-.54-6.582-.383-2.608-.888-4.92-1.376-6.459l.282-1.603-.598.522-.722-.328-.598.522-.722-.328-.597.522-.723-.328-.597.522-.722-.328-.598.521-.722-.328-.598.522-.722-.328-.597.522-.723-.328-.597.522-.722-.328-.598.522-.722-.328-.598.521-.722-.328.73 1.454c-.024 1.614.157 3.974.54 6.582.383 2.608.888 4.92 1.376 6.46l-.282 1.602.598-.522.722.328.597-.522.723.328.597-.521.722.328.598-.522.722.328.598-.522.722.328.597-.522z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.759 27.994a3.693 3.693 0 107.307-1.073 3.693 3.693 0 00-7.307 1.073z"
      fill={color}
    />
  </Svg>
);
export default PayExclusiveRewards;
